var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getTaskContentWithProgress, } from '../task-progress/get-task-content-with-progress';
var TaskState = /** @class */ (function () {
    function TaskState(isSequential, calculateNodeMap, calculateProgressMap, calculateProgressInfo, lanes, assignments) {
        this.isSequential = isSequential;
        this.calculateNodeMap = calculateNodeMap;
        this.calculateProgressMap = calculateProgressMap;
        this.calculateProgressInfo = calculateProgressInfo;
        this.lanes = lanes;
        this.assignments = assignments;
    }
    Object.defineProperty(TaskState.prototype, "nodeMap", {
        get: function () {
            var _a;
            if (this._nodeMap == null) {
                _a = this.calculateNodeMap(), this._nodeMap = _a[0], this._orderedIds = _a[1];
            }
            return this._nodeMap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TaskState.prototype, "orderedIds", {
        get: function () {
            var _a;
            if (this._orderedIds == null) {
                _a = this.calculateNodeMap(), this._nodeMap = _a[0], this._orderedIds = _a[1];
            }
            return this._orderedIds;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TaskState.prototype, "progressMap", {
        get: function () {
            if (this._progressMap == null)
                this._progressMap = this.calculateProgressMap(this.nodeMap);
            return this._progressMap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TaskState.prototype, "progressInfo", {
        get: function () {
            if (this._progressInfo == null) {
                this._progressInfo = this.calculateProgressInfo(this.nodeMap, this.progressMap);
            }
            return this._progressInfo;
        },
        enumerable: false,
        configurable: true
    });
    TaskState.prototype.calculateContentWithProgress = function () {
        return getTaskContentWithProgress(this.orderedIds, this.nodeMap, this.progressMap, this.progressInfo, this.lanes, this.assignments);
    };
    Object.defineProperty(TaskState.prototype, "contentWithProgress", {
        get: function () {
            if (this._contentWithProgress == null) {
                this._contentWithProgress = this.calculateContentWithProgress();
            }
            return this._contentWithProgress;
        },
        enumerable: false,
        configurable: true
    });
    TaskState.prototype.getPrevAndNextSteps = function (stepId) {
        var _this = this;
        var step = this.nodeMap[stepId];
        // decision steps can have multiple next steps
        // 'artificial-ending' isn't a real step so it's out
        var nextIds = step.children.filter(function (s) { return s !== 'artificial-ending'; });
        // get all steps which has stepId as next step
        // except for the start step which isn't a real step
        var prevIds = Object.keys(this.nodeMap).filter(function (id) { return id !== 'start' && _this.nodeMap[id].children.indexOf(stepId) > -1; });
        var completedPath = this.progressInfo.completedPath;
        var previousStepId = findLastCompletedStep(prevIds, completedPath);
        var nextStepId = nextIds[0];
        return [
            previousStepId != null ? this.nodeMap[previousStepId] : null,
            nextStepId != null ? this.nodeMap[nextStepId] : null,
        ];
    };
    return TaskState;
}());
export { TaskState };
function findLastCompletedStep(stepIds, completedPath) {
    // no need to find anything if it's a single step or no step at all
    if (stepIds.length < 2) {
        return stepIds[0];
    }
    // we try to pick the one last checked off (the last one user visited)
    var reversedCompletedPath = __spreadArray([], completedPath, true).reverse();
    for (var _i = 0, reversedCompletedPath_1 = reversedCompletedPath; _i < reversedCompletedPath_1.length; _i++) {
        var completedStepId = reversedCompletedPath_1[_i];
        for (var _a = 0, stepIds_1 = stepIds; _a < stepIds_1.length; _a++) {
            var prevStepId = stepIds_1[_a];
            if (prevStepId === completedStepId) {
                return prevStepId;
            }
        }
    }
    // none of previous steps were checked off, so we can pick one randomically?
    return stepIds[0];
}
